const getQueryString = (query) =>
  query && Object.keys(query).length ? `?${new URLSearchParams(query).toString()}` : ''

const forwardQueryParams = (location, req) => {
  return `${location}${getQueryString(req.query)}`
}

const createRouteRedirector = (newLocation, isTmp) => (req, res, next) => {
  res.newLocation =
    typeof newLocation === 'function'
      ? newLocation(req, res)
      : forwardQueryParams(newLocation, req)
  res.newStatus = isTmp ? 302 : 301
  next()
}

const mapRoutesRedirector = (server, routesMap, isTmp) => {
  Object.keys(routesMap).forEach((key) => {
    server.use(`${key}$`, createRouteRedirector(routesMap[key], isTmp))
  })
}

const redirector = (req, res, next) => {
  if (res.newLocation && res.newStatus) {
    res.writeHead(res.newStatus, {
      Location: res.newLocation,
    })
    res.end()
  } else {
    next()
  }
}

const urlStyleToIdMapSPA = {
  mla: 'mla9',
  'mla-8': 'mla8',
  apa: 'apa7',
  apa6: 'apa',
  harvard: 'harvard1',
}

const urlStyleToIdMapNonSPA = {
  mla: 'mla8',
  harvard: 'harvard1',
  apa: 'apa7',
}

const getUrlStyle = (style, nonSPA = false) => {
  const aliasMap = nonSPA ? urlStyleToIdMapNonSPA : urlStyleToIdMapSPA
  return Object.keys(aliasMap).find((key) => aliasMap[key] === style) || style
}

module.exports = {
  getQueryString,
  forwardQueryParams,
  createRouteRedirector,
  redirector,
  getUrlStyle,
  urlStyleToIdMap: urlStyleToIdMapSPA,
  mapRoutesRedirector,
}
